// Cart
// ===================
// Represents data for a cart, including `orderTotal`, `tax`, etc.
define(['common/models/base', 'underscore'], function(Base, { each }) {
  // Represents the cart in both the 'cart' page and the 'checkout' page
  var Cart = Base.extend({
    defaults: {
      orderSubTotal: '$0',
      orderTotal: '$0',
      tax: '$0',
      stateTax: '$0',
      countyTax: '$0',
      shipping: '$0',
      amountDue: '$0',
      credits: '$0',
      redeemedGiftCertificateCode: undefined,
      promotionSavings: '$0',
      itemSavings: '$0',
      commerceItems: undefined,
      promotions: [],
      storeCredits: '$0',
      applyStoreCredits: false,
      shippingAddress: undefined,
      billingAddress: undefined,
      klarnaOrderData: undefined,
      applyLoyaltyRewards: false,
      loyaltyRewards: undefined,
    },

    url() {
      return '/Store/cart/currentOrderDetails.json.jsp';
    },

    parse(result) {
      var self = this;
      var data = (result.attributes || result);

      if (data.commerceItems) {
        each(data.commerceItems, function(commerceItem) {
          // HTML unescape product name
          commerceItem.productName = $('<div/>').html(commerceItem.productName)
            .text();

          if (commerceItem.buildConfigJson) {
            BC.buildConfigJson = BC.buildConfigJson || {};
            BC.buildConfigJson[commerceItem.id] = JSON.parse(commerceItem.buildConfigJson);
          }

          commerceItem.subItemDetails = {};
          if (commerceItem.subItemDetailsJson) {
            commerceItem.subItemDetails = JSON.parse(commerceItem.subItemDetailsJson);
          }

          // Object keys need to explicitly exist to update values correctly after removing code
          commerceItem.promotionId = self.getKeyValue('promotionId', commerceItem);
          commerceItem.promotionDescription = self.getKeyValue('promotionDescription', commerceItem);
          commerceItem.detailedUnitPrice = self.getKeyValue('detailedUnitPrice', commerceItem);
        }, self);

        self.get('commerceItems').set(data.commerceItems);

        var cartItemsCount = self.getCommerceItemsTotal();

        $.publish('cart:count-updated', cartItemsCount);
        $.publish('cart:updated', data.commerceItems);

        delete data.commerceItems;
      }

      return data;
    },

    getKeyValue(key, commerceItem) {
      return key in commerceItem ? commerceItem[key] : undefined;
    },

    getCommerceItemsTotal() {
      return this.get('commerceItems').reduce(
        function(count, commerceItem) {
          return count + commerceItem.get('quantity');
        }, 0,
      );
    },

    fetch(attrs) {
      attrs || (attrs = {});
      attrs.data || (attrs.data = {});
      // The server requires these parameters for some reason
      $.extend(attrs.data, {
        orderTotals: false,
        orderSubTotal: this.get('orderSubTotal'),
        orderTotal: this.get('orderTotal'),
        tax: this.get('tax'),
        shipping: this.get('shipping'),
        credits: this.get('credits'),
        amountDue: this.get('amountDue'),
        promotionSavings: this.get('promotionSavings'),
      });

      return Base.prototype.fetch.call(this, attrs);
    },

    // Retrieves pricing data such as tax, shipping amount, etc.
    fetchTopLevelOrderInfo(data, callback) {
      var self = this;
      var topLevelOrderData = $.extend({ topLeverOrderInfo: true }, data);

      if (!self.pendingDataFetch) {
        self.pendingDataFetch = [];
      }

      if (!self.dataFetchInProgress) {
        BC.publish('current.order.details.updating');
        self.dataFetchInProgress = true;
        self.fetch({
          data: topLevelOrderData,
          url: self.url(),
          success: (data) => {
            callback && callback(data);
            self.dataFetchInProgress = false;
            self.handlePendingFetchRequest(data);
          },
          error(defaultData, jqXHR) {
            self.dataFetchInProgress = false;
            self.handlePendingFetchRequest(defaultData, true);
            self.trigger('currentOrderDetailsError');
            $.error('Error fetching top level order info. Status: ' + jqXHR.status + ', Message: ' + jqXHR.statusText, 'common/models/cart.js');
          },
        });
      } else {
        self.pendingDataFetch.push({ callback, data: topLevelOrderData });
      }
    },

    handlePendingFetchRequest(responsedata, isError) {
      if (this.pendingDataFetch.length) {
        this.fetchTopLevelOrderInfo(
          this.pendingDataFetch[0].data,
          this.pendingDataFetch[0].callback
        );
        this.pendingDataFetch.shift();
      } else if (!isError) {
        BC.publish('current.order.details.updated', responsedata);
      }
    },

    // Sends a coupon code to the server for validation
    redeemCoupon(data, attrs) {
      var model = this;

      attrs || (attrs = {});

      return this.sync('redeemCoupon', this, $.extend(attrs, {
        data,
        success() {
          model.fetch({
            success: model.trigger('redeemCouponSuccess'),
          });
        },
      }));
    },

    addJsonItem(json, attrs) {
      return this.sync('addJson', this, $.extend(attrs, {
        data: {
          jsonAddItemData: json,
        },
      }));
    },

    addGiftCert(data, attrs) {
      return this.sync('addGiftCert', this, $.extend(attrs, {
        data,
      }));
    },

    addItem(data, attrs) {
      return this.sync('add', this, $.extend(attrs, {
        data: {
          catalogRefIds: data.id,
          groupedItem: data.groupedItem,
          productId: data.productId,
          quantity: data.quantity || 1,
          showBackorderMessage: data.showBackorderMessage,
          skipGiftOrPackageCheck: false,
        },
      }));
    },

    removeItem(data, attrs) {
      return this.sync('remove', this, $.extend(attrs, {
        data: {
          removalCommerceIds: data.id,
        },
      }));
    },

  });

  return Cart;
});
